import { isObject } from '../isObject';

export function clone(instance) {
  if (instance instanceof Node) return instance;

  if (Array.isArray(instance) || instance instanceof NodeList) {
    const result = [];

    for (let index = 0; index < instance.length; index++) {
      result.push(clone(instance[index]));
    }

    return result;
  }

  if (isObject(instance)) {
    const result = {};

    for (const key in instance) {
      if (instance.hasOwnProperty(key)) {
        result[key] = clone(instance[key]);
      }
    }

    return result;
  }

  return instance;
}
